<template>
  <Card>
    <p slot="title">物料信息列表</p>
    <template slot="extra">
      <Button type="primary" icon="md-cloud-upload" @click="exportAction()"
        >数据导出</Button
      >
      <Button type="primary" icon="ios-search" @click="handleSearch()"
        >查询</Button
      >
      <Button type="primary" icon="md-sync" @click="reset()">刷新</Button>
      <Button type="primary" icon="md-add" @click="add()">添加</Button>
    </template>
    <Row>
      <Col span="24">
        <Input
          v-model="params.code"
          placeholder="请输入物料编号"
          class="public-inp"
        />
        <Select
          v-model="params.materialTypeCode"
          placeholder="请选择物料类型"
          class="public-inp"
        >
          <Option
            v-for="(item, index) in typeCodeList"
            :key="index"
            :value="item.materialTypeCode"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          v-model="params.brandCode"
          placeholder="请选择品牌"
          class="public-inp"
        >
          <Option
            v-for="(item, index) in brancCodeList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          >
        </Select>
        <Input
          v-model="params.batchNumber"
          placeholder="请输入批次号"
          class="public-inp"
        />
        <Input
          v-model="params.qrBaseCode"
          placeholder="请输入二维码基础编码"
          class="public-inp"
        />
        <Select
          v-model="params.status"
          placeholder="请选择物料状态"
          class="public-inp"
        >
          <Option value="0">有效</Option>
          <Option value="1">失效</Option>
        </Select>
        <Input
          v-model="params.name"
          placeholder="请输入物料名称"
          class="public-inp"
        />
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ index }" slot="sort">
            {{ (params.pageNum - 1) * params.pageSize + index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a href="javascript:;" @click="toDetail(row)">查看</a>
            <a href="javascript:;" @click="edit(row)">编辑</a>
          </template>
          <template slot-scope="{ row }" slot="materialTypeCode">
            {{ row.materialTypeCode | showTypeName(typeCodeList) }}
          </template>
        </Table>
        <Page
          :total="total"
          :page-size="params.pageSize"
          :current="params.pageNum"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
          class="public-page"
        />
      </Col>
    </Row>
  </Card>
</template>
<script>
const columns = [
  {
    title: "序号",
    slot: "sort",
    fixed: "left",
    width: 66,
  },
  {
    title: "物料编号",
    key: "code",
    width: 100,
  },
  {
    title: "物料名称",
    key: "name",
    width: 120,
  },
  {
    title: "物料类型",
    slot: "materialTypeCode",
    width: 100,
  },
  {
    title: "物料简称",
    key: "shortName",
    width: 100,
  },
  {
    title: "品牌编号",
    key: "brandCode",
    width: 100,
  },
  {
    title: "批次号",
    key: "batchNumber",
    width: 100,
  },
  {
    title: "二维码基础编码",
    key: "qrBaseCode",
    width: 100,
  },
  {
    title: "二维码尺寸",
    key: "qrSize",
    width: 100,
  },
  {
    title: "下发数量",
    key: "sendNum",
    width: 100,
  },
  {
    title: "补发数量",
    key: "resendNum",
    width: 100,
  },

  {
    title: "物料状态",
    key: "status",
    width: 100,
    render(h, params) {
      // 0：有效；1：失效
      let s = params.row.status;
      let t = s == 0 ? "生效" : "失效";
      return h("span", t);
    },
  },
  {
    title: "备注",
    key: "remark",
    width: 100,
  },

  {
    title: "操作",
    slot: "action",
    fixed: "right",
    width: 130,
  },
];
var tyCode = [];
export default {
  data() {
    return {
      typeCodeList: [],
      brancCodeList: [],
      params: {
        batchNumber: "",
        brandCode: "",
        code: "",
        materialTypeCode: "",
        name: "",
        pageNum: 1,
        pageSize: 10,
        qrBaseCode: "",
        status: "",
      },
      total: 0,
      columns,
      tbList: [],
      loading: false,
    };
  },
  filters: {
    showTypeName(s, list) {
      let t = list.filter((item) => item.materialTypeCode == s);
      if (t && t.length > 0) {
        return t[0].name;
      }
    },
  },
  created() {
    this.getList();
    this.getBrandList();
    this.getMaterialType();
  },
  methods: {
    handleSearch() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.getList();
    },
    getMaterialType() {
      this.$api.materManType().then((res) => {
        if (res.code == 200) {
          this.typeCodeList = res.data;
        }
      });
    },
    getBrandList() {
      this.$api.brandAll().then((res) => {
        if (res.code == 200) {
          this.brancCodeList = res.data;
          this.brancCodeList.unshift({
            code: "-1",
            name: "ALL",
          });
        }
      });
    },
    getList() {
      this.loading = true;
      let params = this.params;
      this.$api.materManList(params).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.tbList = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    edit(e) {
      this.$router.push({
        path: "materialAdd",
        query: {
          code: e.code,
        },
      });
    },
    toDetail(e) {
      this.$router.push({
        path: "materDetial",
        query: {
          code: e.code,
        },
      });
    },
    // 页码
    pageChange(d) {
      this.params.pageNum = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.params.pageSize = d;
      this.getList();
    },
    // 重置
    reset() {
      this.params.batchNumber = "";
      this.params.brandCode = "";
      this.params.code = "";
      this.params.materialTypeCode = "";
      this.params.name = "";
      this.params.qrBaseCode = "";
      this.params.status = "";
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    // 新增
    add() {
      this.$router.push({
        path: "materialAdd",
      });
    },
    exportAction() {
      let data = this.params;
      this.$api.materManExport(data).then((res) => {
        if (res.code == "200") {
          try {
            let elemIF = document.createElement("iframe");
            elemIF.src = res.data.url;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
          } catch (e) {
            this.$Message.error("下载异常！");
          }
        } else {
          this.$Message.error("导出失败" + res.message);
        }
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/material/list.vue